/**
 * PREDICTIVE COHORT DIALER (2026-09-16).
 *
 * Cohort's predictive-call equivalent of CohortStartDialer.js's floating
 * cockpit — SAME DialerCallPane component (Shailendra: "use progressive
 * dialer UI only, not functionality"), same floating-bottom-right placement,
 * same `showBuyerInfo` (name + last order) — but fed a synthetic status built
 * from GET /voice/predictive/status (Phonomenal's native engine) instead of
 * the progressive queue's GET /voice/dialer/status, since a predictive call
 * was placed by Phonomenal itself, not by our own backend queue.
 *
 * Self-gates to agents with BOTH admins.cohortTeam:true AND
 * admins.predictiveDialer:true (the status endpoint returns isCohort itself,
 * so no separate cohort check is needed here beyond that flag).
 */
import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import DialerCallPane from '../../../menu-items/Dashboard/DialerCallPane';
import usePredictiveStatus from '../../../hooks/usePredictiveStatus';

export default function PredictiveCohortDialer() {
  const [st, , refresh] = usePredictiveStatus();

  const isCohort = !!st?.enabled && !!st?.isCohort;
  const dialer = (st?.status === 'on_call' || st?.status === 'disposing_call')
    ? {
        active: true,
        callState: st.status === 'on_call' ? 'dialing' : 'ended',
        state: null,
        current: {
          phone: st.pendingCall?.phone,
          dialedAt: st.pendingCall?.connectedAt || st.pendingCall?.startedAt,
          talktime: st.pendingCall?.talktime,
          whatsappWindowOpen: false,
        },
      }
    : null;

  if (!isCohort || !dialer) return null;

  return (
    <Paper
      elevation={8}
      style={{
        position: 'fixed', right: 16, bottom: 16, zIndex: 1400,
        width: 300, maxHeight: '80vh', overflow: 'hidden', borderRadius: 10,
        display: 'flex', flexDirection: 'column',
      }}
    >
      <Box style={{ display: 'flex', alignItems: 'center', padding: '6px 10px', background: '#eef4fd', borderBottom: '1px solid #e0e0e0' }}>
        <Typography style={{ fontWeight: 800, fontSize: 12, color: '#1565c0' }}>Predictive Call</Typography>
      </Box>
      <Box style={{ overflowY: 'auto' }}>
        <DialerCallPane
          dialer={dialer}
          cohort
          isPredictive
          showBuyerInfo
          onEnded={refresh}
          onSubmitted={refresh}
          onRefreshChat={() => {}}
        />
      </Box>
    </Paper>
  );
}
